import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const SVG = styled.svg`
  cursor: pointer;
  width: 100%;
  height: 100%;

  rect {
    fill: #fff;
    height: 3px;
    width: 109%;
  }

  path {
    fill: #fff;
  }

  .bar-1 {
    transform: rotate(45deg);
    transform-origin: 0 25%;
  }

  .bar-2 {
    transform: rotate(-45deg);
    transform-origin: 0 75%;
  }
`

function Close(props) {
  const { onClick, className } = props
  return (
    <SVG onClick={onClick} className={className} viewbox="0 0 24 24">
      <g>
        <path
          d="M13.595005,9.90269729 L13.595005,5.28277971 C13.595005,4.26511833 12.7684537,3.44115883 11.7488511,3.44115883 C10.72214,3.44115883 9.90269729,4.26568058 9.90269729,5.28277971 L9.90269729,9.90269729 L5.28277971,9.90269729 C4.26511833,9.90269729 3.44115883,10.7292485 3.44115883,11.7488511 C3.44115883,12.7755622 4.26568058,13.595005 5.28277971,13.595005 L9.90269729,13.595005 L9.90269729,18.2149226 C9.90269729,19.2325839 10.7292485,20.0565434 11.7488511,20.0565434 C12.7755622,20.0565434 13.595005,19.2320217 13.595005,18.2149226 L13.595005,13.595005 L18.2149226,13.595005 C19.2325839,13.595005 20.0565434,12.7684537 20.0565434,11.7488511 C20.0565434,10.72214 19.2320217,9.90269729 18.2149226,9.90269729 L13.595005,9.90269729 Z"
          id="Combined-Shape"
          fill="#000000"
          transform="translate(11.748851, 11.748851) rotate(45.000000) translate(-11.748851, -11.748851) "
        ></path>
      </g>
    </SVG>
  )
}

Close.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}

export default Close



// WEBPACK FOOTER //
// ./src/images/icons/Close.js